import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "./features/modalSlice";
import tableReducer from "./features/tableSlice";
import authReducer from "./features/authSlice";
import { baseApi } from "./services/baseApi";
import {statusApi} from"./services/CommonApi/changeStatusApis"
import filtersReducer from"./features/filtersSlice"
export const store = configureStore({
  reducer: {
    auth: authReducer,
    modal: modalReducer,
    table: tableReducer,
    filters: filtersReducer,
    [baseApi.reducerPath]: baseApi.reducer,
     [statusApi.reducerPath]: statusApi.reducer,
  },
     middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});